export const API_BASE_FINANCE_ENV_URL = process.env.REACT_APP_API_BASE_FINANCE_URL
export const API_BASE_COR_ID_ENV_URL = process.env.REACT_APP_AUTH_API_BASE_COR_ID_URL;

const API_BASE_FINANCE_URL: string = `${API_BASE_FINANCE_ENV_URL}/v1`
const API_BASE_COR_ID_URL: string = `${API_BASE_COR_ID_ENV_URL}`

//AUTH - form COR_ID
const AUTH_COR_ID: string = `${API_BASE_COR_ID_URL}/auth`;
export const API_AUTH_COR_ID_BY_EMAIL: string = `${AUTH_COR_ID}/login`;
export const API_AUTH_ME: string = `${AUTH_COR_ID}/me`;
export const API_AUTH_COR_ID_GET_QR: string = `${AUTH_COR_ID}/web/initiate-login`;
export const API_AUTH_GET_FINANCE_TOKEN: string = `${API_BASE_COR_ID_URL}/partner/finance-login`;
export const API_AUTH_REFRESH_COR_ID_URI: string = `${API_BASE_COR_ID_URL}/auth/refresh_token`;

//AUTH - form FINANCE
export const API_AUTH_REFRESH_FINANCE_URI: string = `${API_BASE_FINANCE_URL}/partner_auth/refresh`;

const COMPANY: string = `${API_BASE_FINANCE_URL}/partner_companies`;
export const API_MAKE_LIST_COMPANY_URI = (ownerCorId: string) => `${COMPANY}/${ownerCorId}`
export const API_MAKE_LIST_COMPANY_USERS_URI = (company_id: string) => `${API_BASE_COR_ID_URL}/partner/company-members?company_id=${company_id}`

const TRANSACTION: string = `${API_BASE_FINANCE_URL}/partner_transactions/`;
export const API_LIST_COMPANY_TRANSACTION_URI = `${TRANSACTION}`

const ACCOUNT: string = `${API_BASE_FINANCE_URL}/account_members`;
export const API_CREATE_ACCOUNT_MEMBER_URI = `${API_BASE_COR_ID_URL}/partner/add-employee`
export const API_MAKE_DELETE_ACCOUNT_MEMBER_URI = (memberId: string) => `${ACCOUNT}/${memberId}`
export const API_MAKE_BLOCK_ACCOUNT_MEMBER_URI = (memberId: string) => `${ACCOUNT}/${memberId}/disable`
export const API_MAKE_CHANGE_LIMIT_ACCOUNT_MEMBER_URI = (memberId: string) => `${ACCOUNT}/${memberId}/limits`
export const API_MAKE_CANCEL_INVITE_MEMBER_URI = (invitationId: string) => `${API_BASE_COR_ID_URL}/partner/company-invitations/${invitationId}`
